import { ref } from 'vue'
import Api from '@/api'
import store from '@/store'
import { VideoResponseWithProgress } from '@/types/cms';


const loggingEnabled = process.env.NODE_ENV !== 'production';
const log = (msg: string) => { if (loggingEnabled) console.log(`[CMSContinueWatchingManager] ${msg}`) }
type LoadingState = 'loading' | 'error' | 'success'

const videos = ref<VideoResponseWithProgress[] | undefined>(undefined)
const state = ref<LoadingState>('loading')

async function loadContinueWatchingRail() {
  try {
    log('Loading continue watching rails...')
    const response = await Api.CMS.continueWatchingRail()
    videos.value = response
    log(`Got ${response.length} continue watching videos`)
    state.value = 'success'

    store.commit('CACHE_CONTENT', { videos: response })
  } catch (error) {
    log(`Failed to fetch rails: ${error}`)
    state.value = 'error'
  }
}


export const CMSContinueWatchingManager = {
  videos,
  state,
  loadContinueWatchingRail
}